// src/Monetization/AdSlot.js
// Componente reutilizable para slots de Google AdSense.
// Mientras AdSense no está aprobado, muestra un placeholder invisible.
// Una vez aprobado, descomentar el ins de AdSense y añadir el data-ad-slot de cada slot.

import React, { useEffect, useRef } from 'react';
import { usePlan } from '../context/PlanContext';
import './AdSlot.css';

// IDs de slots de AdSense — rellenar cuando llegue la aprobación
export const AD_SLOTS = {
  feedCard:      '',   // Tarjeta entre recetas del feed
  chatBanner:    '',   // Banner sobre el input del chat
  detailBanner:  '',   // Banner inferior en RecipeDetail
  vignette:      '',   // Pantalla completa al abrir receta (auto-ads)
};

const AD_CLIENT = 'ca-pub-2719245844633553';

/**
 * AdSlot — muestra un anuncio de AdSense solo a usuarios básicos (no Premium).
 *
 * Props:
 *  - slotId: string — clave de AD_SLOTS (feedCard, chatBanner, detailBanner...)
 *  - format: 'auto' | 'rectangle' | 'horizontal' | 'vertical'  (default: 'auto')
 *  - style: objeto CSS adicional para el contenedor
 */
const AdSlot = ({ slotId, format = 'auto', style = {} }) => {
  const { isPremium } = usePlan();
  const adRef = useRef(null);
  const slotDataId = AD_SLOTS[slotId] || '';
  const isReady = Boolean(slotDataId); // true cuando tengamos el ID de AdSense

  useEffect(() => {
    if (!isReady || isPremium) return;
    try {
      // Inicializar el slot cuando el componente se monta
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (e) {
      // AdSense aún no cargado o bloqueado por adblocker
    }
  }, [isReady, isPremium]);

  // Usuarios Premium: no se muestra nada
  if (isPremium) return null;

  // Slot pendiente de ID: no renderizar nada (placeholder invisible)
  if (!isReady) return null;

  return (
    <div className="ad-slot-wrapper" style={style} ref={adRef}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client={AD_CLIENT}
        data-ad-slot={slotDataId}
        data-ad-format={format}
        data-full-width-responsive="true"
      />
    </div>
  );
};

export default AdSlot;
